// bootstrap
import "../../node_modules/bootstrap/scss/bootstrap-reboot.scss";
import "../../node_modules/bootstrap/scss/bootstrap-grid.scss";
import "../../node_modules/bootstrap/scss/bootstrap-utilities.scss";

// style
import "../scss/styles.scss";

// js
import "./scripts/home.js";
import "./scripts/header.js";
import "./scripts/footer.js";
import "./scripts/slick-carousel.js";
